import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import LockIcon from "@mui/icons-material/Lock";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};


export default function HitterPitchProfile(props: any) {
  const [pitchData, setPitchData] = useState<any[]>([]);
  useEffect(() => {
    fetch(props.prod ? "https://oriolebird.pythonanywhere.com/hitter-pitches/" + props.id + '/' + props.season + '/' + props.level : "/hitter-pitches/" + props.id + '/' + props.season + '/' + props.level)
      .then((res) => res.json())
      .then((pData) => {
        console.log("Pitch Data for ",props.season, pData);
        setPitchData(pData)
      });
  }, [props.id, props.prod, props.season, props.level]);
  
  const temp = Object.keys(props).includes('teamInfoProp')
  if(temp){
    props.playerInfoProp.common = {teamInfo: props.teamInfoProp}
  }
  
  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={2}
      >
        <Grid maxWidth="90vw">
        <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "570px" :" 100%",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
              <div
                style={{
                  width: "100%",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  backgroundColor:
                    props.playerInfoProp.common.teamInfo.MLB_AbbName !== null
                      ? teamColors[props.playerInfoProp.common.teamInfo.MLB_AbbName][0]
                      : teamColors["FA"][0],
                }}
              >
                {props.isDesktop &&
                  (<Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="h5">
                      <span
                        style={{
                          color:
                            props.playerInfoProp.common.teamInfo.MLB_AbbName !== null
                              ? teamColors[
                              props.playerInfoProp.common.teamInfo.MLB_AbbName
                              ][1]
                              : teamColors["FA"][1],
                          fontWeight: "bold",
                          fontSize: "25pt",
                          textAlign: "center"
                        }}
                      >
                        Pitch Type Performance
                      </span>
                    </Typography>
                  </Grid>)}
                {!props.isDesktop &&
                  (<Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  ><Typography variant="h5" style={{ fontSize: "25pt" }}>
                      <div
                        style={{
                          color:
                            props.playerInfoProp.common.teamInfo.MLB_AbbName !== null
                              ? teamColors[
                              props.playerInfoProp.common.teamInfo.MLB_AbbName
                              ][1]
                              : teamColors["FA"][1],
                          fontWeight: "bold",
                          textAlign: "center"
                        }}
                      >
                        Pitch Type Performance
                      </div>
                    </Typography></Grid>)}
              </div>
              <TableContainer component={Paper} style={{margin: "10px"}}>
                  <Table size="small" padding="normal" sx={{ marginLeft: "10px", width: "95%"  }}>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{width: "10px"}}>Pitch Type</TableCell>
                        <TableCell >Usage</TableCell>
                        {props.isPlus && (
                          <>
                            <TableCell>
                              <Tooltip title="Run Value per 100 pitches faced (hitter perspective: positive = batter benefiting)" placement="top">
                                <span>RV/100</span>
                              </Tooltip>
                            </TableCell>
                            <TableCell>
                              <Tooltip title="Total Run Value (hitter perspective: positive = batter benefiting)" placement="top">
                                <span>RV</span>
                              </Tooltip>
                            </TableCell>
                          </>
                        )}
                        {!props.isPlus && (
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "3px", color: "#888", whiteSpace: "nowrap" }}>
                              <a href="/plus" style={{ color: "#888", textDecoration: "none", fontSize: "0.75rem", display: "flex", alignItems: "center", gap: "3px" }}>
                                <LockIcon sx={{ fontSize: "0.75rem" }} />
                                RV
                              </a>
                            </Box>
                          </TableCell>
                        )}
                        <TableCell >xwOBA</TableCell>
                        <TableCell >xSLG</TableCell>
                        <TableCell >xBA</TableCell>
                        <TableCell >Whiff%</TableCell>
                        <TableCell >HardHit%</TableCell>
                        <TableCell >Swing%</TableCell>
                        <TableCell >Velo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pitchData.length > 0 && pitchData.map((pitch) => <TableRow
                        key={pitch.pitch_type}
                      >
                        <TableCell ><span style={{fontWeight: "bold"}}>{pitch.pitch_name}</span></TableCell>
                        <TableCell >{pitch.pitch_percent}%</TableCell>
                        {props.isPlus && (() => {
                          const rv100 = pitch.batter_run_value_per_100 ?? 0;
                          const rv = rv100 * ((pitch.swings ?? 0) + (pitch.takes ?? 0)) / 100;
                          const rv100Color = rv100 > 0.5 ? "#1a7c1a" : rv100 < -0.5 ? "#c0392b" : "inherit";
                          const rvColor = rv > 0.5 ? "#1a7c1a" : rv < -0.5 ? "#c0392b" : "inherit";
                          return (
                            <>
                              <TableCell sx={{ color: rv100Color, fontWeight: Math.abs(rv100) > 0.5 ? "bold" : "normal" }}>
                                {rv100.toFixed(1)}
                              </TableCell>
                              <TableCell sx={{ color: rvColor, fontWeight: Math.abs(rv) > 0.5 ? "bold" : "normal" }}>
                                {rv.toFixed(1)}
                              </TableCell>
                            </>
                          );
                        })()}
                        {!props.isPlus && (
                          <TableCell sx={{ filter: "blur(4px)", userSelect: "none", pointerEvents: "none", color: "#888", fontSize: "0.75rem" }}>0.0</TableCell>
                        )}
                        <TableCell >{pitch.xwoba !== null ? pitch.xwoba.toFixed(3).toString().replace(/^0/, "") : "-"}</TableCell>
                        <TableCell >{pitch.xslg !== null ? (pitch.xslg>=1 ? pitch.xslg :pitch.xslg.toFixed(3).toString().replace(/^0/, ""))  : "-"}</TableCell>
                        <TableCell >{pitch.xba !== null ? pitch.xba.toFixed(3).toString().replace(/^0/, "")  : "-"}</TableCell>
                        <TableCell >{pitch.swings !== null ? (pitch.whiffs/pitch.swings*100).toFixed(2).toString()  : "-"}</TableCell>
                        <TableCell >{pitch.hardhit_percent !== null ? (pitch.hardhit_percent).toFixed(2).toString()  : "-"}</TableCell>
                        <TableCell >{pitch.swings !== null ? (pitch.swings/(pitch.swings+pitch.takes)*100).toFixed(1).toString()  : "-"}</TableCell>
                        <TableCell >{pitch.velocity !== null ? pitch.velocity.toFixed(1).toString() : "-"}</TableCell>
                      </TableRow>)}
                    </TableBody>
                  </Table>
                </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}